export default "__VITE_ASSET__Dxo$LKJk__"